import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconSliceChevronUp = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--slice-chevron-up")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_3688_40196" style={{ maskType: "alpha", }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  <rect width="24" height="24" fill="currentColor"/>
  </mask>
  <g mask="url(#mask0_3688_40196)">
  <path d="M7.40002 15.0382L6.34619 13.9844L12 8.33057L17.6538 13.9844L16.6 15.0382L12 10.4382L7.40002 15.0382Z" fill="currentColor"/>
  </g>
  </IconWrapper>
)
